import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import Impressum from "./pages/Impressum.tsx";
import Datenschutz from "./pages/Datenschutz.tsx";
import Transparenz from "./pages/Transparenz.tsx";
import Gen30Vision from "./pages/Gen30Vision.tsx";
import RotlichtErkaeltung from "./pages/RotlichtErkaeltung.tsx";
import HeilysPartnerlink from "./pages/HeilysPartnerlink.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/transparenz" element={<Transparenz />} />
            <Route path="/gen30-vision" element={<Gen30Vision />} />
            <Route path="/rotlicht-erkaeltung" element={<RotlichtErkaeltung />} />
            <Route path="/heilys-partnerlink" element={<HeilysPartnerlink />} />
            {/* Alt-URL: Weiterleitung auf die neutrale URL */}
            <Route path="/heilys-cashback" element={<Navigate to="/heilys-partnerlink" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
